import { paragraphArial } from "../results/paragraphs";

export const averageLines = (average) => {
  return [
    paragraphArial(""),
    paragraphArial(`Durchschnitt (Punkte): ${average.toFixed(2)}`),
    paragraphArial(`Die Klausuren von 3 Schülerinnen und Schülern liegen bei.`),
  ];
};
